import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CampaignManagementDTO, CampaignRewardItemForListDto, CommonImportFileResponse, CreateOrEditCampaignManagementDto, CreateOrEditChallengeFollowInput, CreateOrEditChallengeFollowResponse, CreateOrEditChallengeInput, CreateOrEditChallengeResponse, CreateOrEditOutletInfoDto, GetAllRetailerUpdatePhoneInput, GetChallengeHeaderForEditResponse, GetOutletInfoForEditOutput, OutletInfosImportAgrs, PagedResultDtoOfCampaignManagementDTO, PagedResultDtoOfGetListChallengeFollowForEditResponse, PagedResultDtoOfGetListChallengeHeaderResponse, PagedResultDtoOfGetListChallengeResultForEditResponse, PagedResultDtoOfOutletInfoUpdateHistoryDto, PagedResultDtoOfRewardItemResourceDTO, RewardItemForListDto, SocialRetailerFileDto, UpdateActiveDto } from '@shared/service-proxies/service-proxies';
import { PagedResultDtoOfGetOutletInfoForViewDto } from '@shared/service-proxies/service-proxies';
import { API_ENDPOINTS } from '@shared/APIEndpoint';
import * as moment from "moment";
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from './base-api-service';
import { AppConsts } from '@shared/AppConsts';

@Injectable({ providedIn: 'root' })
export class CampaignService extends BaseApiService {
  protected prefix = AppConsts.apiGatewayCampaignPrefix;

  constructor(api: ApiService) {
    super(api);
  }

  getListChallengeHeader(
    programCode?: string,
    programName?: string,
    imageType?: string,
    status?: string,
    fromDate?: moment.Moment,
    toDate?: moment.Moment,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): Observable<PagedResultDtoOfGetListChallengeHeaderResponse> {
    const url = API_ENDPOINTS.Challenge.GetListChallengeHeader;

    let params = new HttpParams();

    if (programCode != null) params = params.set("ProgramCode", programCode);
    if (programName != null) params = params.set("ProgramName", programName);
    if (imageType != null) params = params.set("ImageType", imageType);
    if (status != null) params = params.set("Status", status);
    if (fromDate != null) params = params.set("FromDate", fromDate.toJSON());
    if (toDate != null) params = params.set("ToDate", toDate.toJSON());
    if (sorting != null) params = params.set("Sorting", sorting);
    if (skipCount != null) params = params.set("SkipCount", skipCount.toString());
    if (maxResultCount != null) params = params.set("MaxResultCount", maxResultCount.toString());

    return this.get<PagedResultDtoOfGetListChallengeHeaderResponse>(url, params);
  }

  getChallengeHeaderForEdit(id?: number): Observable<GetChallengeHeaderForEditResponse> {

    const url = API_ENDPOINTS.Challenge.GetChallengeHeaderForEdit;

    let params = new HttpParams();
    if (id != null) params = params.set("Id", id.toString());

    return this.get<GetChallengeHeaderForEditResponse>(url, params);
  }

  getListChallengeFollowForEdit(
    challengeId?: number,
    status?: number,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): Observable<PagedResultDtoOfGetListChallengeFollowForEditResponse> {
    const url = API_ENDPOINTS.Challenge.GetListChallengeFollowForEdit;

    let params = new HttpParams();
    if (challengeId != null) params = params.set('ChallengeId', challengeId.toString());
    if (status != null) params = params.set('Status', status.toString());
    if (sorting != null) params = params.set('Sorting', sorting);
    if (skipCount != null) params = params.set('SkipCount', skipCount.toString());
    if (maxResultCount != null) params = params.set('MaxResultCount', maxResultCount.toString());

    return this.get<PagedResultDtoOfGetListChallengeFollowForEditResponse>(url, params);
  }

  getListChallengeResultForEdit(
    challengeId?: number,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): Observable<PagedResultDtoOfGetListChallengeResultForEditResponse> {
    const url = API_ENDPOINTS.Challenge.GetListChallengeResultForEdit;

    let params = new HttpParams();
    if (challengeId != null) params = params.set('ChallengeId', challengeId.toString());
    if (sorting != null) params = params.set('Sorting', sorting);
    if (skipCount != null) params = params.set('SkipCount', skipCount.toString());
    if (maxResultCount != null) params = params.set('MaxResultCount', maxResultCount.toString());

    return this.get<PagedResultDtoOfGetListChallengeResultForEditResponse>(url, params);
  }

  createOrEditChallenge(
    input: CreateOrEditChallengeInput
  ): Observable<CreateOrEditChallengeResponse> {
    const url = API_ENDPOINTS.Challenge.CreateOrEditChallenge;
    return this.post<CreateOrEditChallengeResponse>(url, input);
  }


  createOrEditChallengeFollow(input: CreateOrEditChallengeFollowInput | null | undefined): Observable<CreateOrEditChallengeFollowResponse> {

    const url = API_ENDPOINTS.Challenge.CreateOrEditChallengeFollow;
    return this.post<CreateOrEditChallengeResponse>(url, input);

  }


  downloadTempFile(
    fileName?: string,
    fileType?: string,
    fileToken?: string
  ): Observable<Blob> {
    const url = API_ENDPOINTS.File.DownloadTempFile;

    let params = new HttpParams();
    if (fileName != null) params = params.set("FileName", fileName);
    if (fileType != null) params = params.set("FileType", fileType);
    if (fileToken != null) params = params.set("FileToken", fileToken);

    return this.getBlob(url, params);
  }

}
